import React from 'react';
import { Route } from 'common/types/tech';
import { RoutesAvailability } from './routes-availability';

const PipelineCreationBasic = React.lazy(() => import('modules/video-app/pipeline-creation/pipeline-creation-basic'));
const PipelineCreationChat = React.lazy(() => import('modules/video-app/pipeline-creation/pipeline-creation-chat'));
const Dashboard = React.lazy(() => import('modules/video-app/dashboard'));
const VideoRedirectPage = React.lazy(() => import('modules/video-app/redirect-page'));
const VideoUsersSettings = React.lazy(() => import('modules/video-app/users-settings'));
const VideoChannelsSettings = React.lazy(() => import('modules/video-app/entities-settings/tenants-settings'));
const VideoBrandsSettings = React.lazy(() => import('modules/video-app/entities-settings/brands-settings'));
const AssetsPlaygroundPage = React.lazy(() => import('modules/video-app/assets-playground-page'));
const TrendsPage = React.lazy(() => import('modules/video-app/trends'));
const ChannelPostsPage = React.lazy(() => import('modules/video-app/channel-posts'));

export const getVideoAppRoutes = (): Array<Route> => [
  {
    path: '/',
    preview: 'Dashboard',
    component: Dashboard,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/video-creation',
    preview: 'Video Creation',
    component: PipelineCreationBasic,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/video-creation/:pipeline_id',
    preview: 'Video Creation',
    component: PipelineCreationBasic,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/vc-chat',
    preview: 'Video Creation Chat',
    component: PipelineCreationChat,
    checkAvailability: () => true,
    hiddenLayout: true,
    protected: true,
  },
  {
    path: '/vc-chat/:pipeline_id',
    preview: 'Video Creation Chat',
    component: PipelineCreationChat,
    checkAvailability: () => true,
    hiddenLayout: true,
    protected: true,
  },
  {
    path: '/settings/users',
    preview: 'Users Settings',
    component: VideoUsersSettings,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/settings/channels',
    preview: 'Channels Settings',
    component: VideoChannelsSettings,
    checkAvailability: () => RoutesAvailability.VideoChannelsSettings(),
    protected: true,
  },
  {
    path: '/settings/brands',
    preview: 'Brands Settings',
    component: VideoBrandsSettings,
    checkAvailability: () => RoutesAvailability.VideoChannelsSettings(),
    protected: true,
  },
  {
    path: '/video-redirect',
    preview: 'Video App Redirect',
    component: VideoRedirectPage,
    checkAvailability: () => true,
    hiddenLayout: true,
    protected: true,
  },
  {
    path: '/assets-playground',
    preview: 'Assets Playground',
    component: AssetsPlaygroundPage,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/trends',
    preview: 'Trends',
    component: TrendsPage,
    checkAvailability: () => true,
    protected: true,
  },
  {
    path: '/channel-posts',
    preview: 'Channel Posts',
    component: ChannelPostsPage,
    checkAvailability: () => true,
    protected: true,
  },
];
